import {caseTypes} from "components/Utility/Objects";

///Primitive Types
const stringFieldDefault = "Not Provided";

///Sophisticated Types
const caseTypeDefault = caseTypes.insurance;

const userDefault = {
    name: stringFieldDefault,
    number: stringFieldDefault,
};

export {
    caseTypeDefault,
    stringFieldDefault,
    userDefault,
};